import {Check, X} from 'lucide-react'
import {traditionalTableColumns} from './mockData'

const decisionLabel = {
	approved: 'Aprobado',
	rejected: 'Rechazado',
}

export const IngresoPromocionTradicionalTable = ({rows, onDecision, onOpenProduct}) => {
	return (
		<div className='traditional-management-table-wrapper'>
			<table className='traditional-management-table'>
				<thead>
					<tr>
						<th className='traditional-actions-column'>Acciones</th>
						{traditionalTableColumns.map((column) => (
							<th key={column.key}>{column.label}</th>
						))}
					</tr>
				</thead>
				<tbody>
					{rows.map((row) => (
						<tr key={row.id} className={row.decision ? `traditional-row-${row.decision}` : ''}>
							<td className='traditional-actions-column'>
								<div className='traditional-row-actions'>
									<button
										type='button'
										title='Aprobar fila'
										className={`traditional-row-action approve ${row.decision === 'approved' ? 'active' : ''}`}
										onClick={() => onDecision(row.id, 'approved')}
									>
										<Check size={14} strokeWidth={3} />
									</button>
									<button
										type='button'
										title='Rechazar fila'
										className={`traditional-row-action reject ${row.decision === 'rejected' ? 'active' : ''}`}
										onClick={() => onDecision(row.id, 'rejected')}
									>
										<X size={14} strokeWidth={3} />
									</button>
								</div>
								{row.decision && <span className='traditional-decision-label'>{decisionLabel[row.decision]}</span>}
							</td>
							{traditionalTableColumns.map((column) => (
								<td key={`${row.id}-${column.key}`}>
									{column.key === 'producto' ? (
										<button type='button' className='traditional-product-link' onClick={() => onOpenProduct(row)}>
											{row[column.key]}
										</button>
									) : row[column.key]}
								</td>
							))}
						</tr>
					))}
				</tbody>
			</table>
		</div>
	)
}
